<template>
<div>
    <trademark-form ref="trademarkForm"></trademark-form>
    <context-menu ref="copyMenu"></context-menu>
    <b-modal id="trademarkTransactionReportDetailModal" centered size="xl" no-close-on-backdrop ref="trademarkTransactionReportDetailModal" :title=" $t('trademarkTransactionReportDetail.title') + ' ' + '-' + ' ' + this.row2Value" hide-footer>
        <b-row>
            <b-col class="col-11"> </b-col>
            <b-col class="col-1">
                <div class="d-flex align-items-right">
                    <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" v-b-modal.exportLanguageSelectModal @click="showLanguageSelect = true">
                        {{ $t('excel.excel') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-modal v-if="showLanguageSelect" size="xs" centered id="exportLanguageSelectModal" hide-footer>
            <b-col class="text-right" style="text-align-last: center;">
                <div class="d-inline-flex align-items-center">
                    <b-button-group size="sm">
                        <b-button class="mr-1" variant="outline-primary" size="sm" @click="exportExcel('tr')">{{ $t('excel.turkish') }}</b-button>
                        <b-button variant="outline-info" size="sm" @click="exportExcel('en')">{{ $t('excel.english') }}</b-button>
                    </b-button-group>
                </div>
            </b-col>
        </b-modal>
        <div class="custom-search">
            <!--Row 1-->
            <b-row>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('logo', 'logo', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.logo') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('recordNo','record_no', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.record_no') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('name', 'name',$event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.name') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('applicationDate', 'application_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.application_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('agent', 'agent', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('owner', 'owner', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.owner') }}
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <!--Row 2-->
            <b-row>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('applicationNo', 'application_no', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.application_no') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('niceClass.niceClass', 'nice_class', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.nice_class') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('registerDate', 'register_date',$event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.register_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentNote', 'agent_note', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_note') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('ownerNote', 'owner_note', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.owner_note') }}
                    </b-form-checkbox>
                </b-col>
                <!-- 6. sütunu boş bıraktık -->
                <b-col></b-col>
            </b-row>

            <!--Row 3-->
            <b-row>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('firstRegisterNo', 'first_register_no', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.first_register_no') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('niceClass.goods', 'nice_class_goods', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.nice_class_goods') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('trademarkRenewal.renewalDate', 'renewal_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.renewal_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentAddress.country', 'agent_address_country', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_address_country') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('ownerAddress.country', 'owner_address_country', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.owner_address_country') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 4-->
            <b-row>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('registerNo', 'register_no', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.register_no') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('niceClass.goodsEn', 'nice_class_goods_en', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.nice_class_goods_en') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('trademarkRenewal.nextRenewalDate', 'next_renewal_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.next_renewal_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentReferenceNo', 'agent_reference_no', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_reference_no') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('ownerAddress.countryCode', 'owner_address_country_code', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.owner_address_country_code') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 5-->
            <b-row>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('note', 'note', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.note') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('priorityDate', 'priority_date',$event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.priority_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentResponsible.email', 'agent_responsible_email', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_responsible_email') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('ownerAddress.address', 'owner_address_address', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.owner_address_address') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 6-->
            <b-row>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('invoiceNote', 'invoice_note', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.invoice_note') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('bulletinDate', 'bulletin_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.bulletin_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentAddress.countryCode', 'agent_address_country_code', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_address_country_code') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 7-->
            <b-row>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox :checked="true" name="checkbox" @change.native="changeColumns('trademarkStatus', 'trademark_status',  $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.trademark_status') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('yiDKDate', 'yidk_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.yidk_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('agentResponsible.name', 'agent_responsible_name', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.agent_responsible_name') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 8-->
            <b-row>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('isTakeOver', 'is_take_over', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.is_take_over') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('instructionDate', 'instruction_date', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.instruction_date') }}
                    </b-form-checkbox>
                </b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('renewalAgent', 'renewal_agent', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.renewal_agent') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 9-->
            <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('renewalAgentResponsible.email', 'renewal_agent_responsible_email', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.renewal_agent_responsible_email') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>

            <!--Row 10-->
            <b-row>
                <b-col></b-col>
                <b-col></b-col>
                <b-col></b-col>
                <b-col>
                    <b-form-checkbox name="checkbox" @change.native="changeColumns('renewalAgentResponsible.name', 'renewal_agent_responsible_name', $event.target.checked)">
                        {{ $t('trademarkTransactionReportDetail.renewal_agent_responsible_name') }}
                    </b-form-checkbox>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>
        </div>

        <!-- table -->
        <vue-good-table id="trademarkTransactionReportDetailTable" ref="trademarkTransactionReportDetailTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" :search-options="{
        enabled: true,
        externalQuery: searchTerm }" :pagination-options="{
        enabled: true,
        perPage:pageLength
      }">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">

            </template>
            <!-- Column: Table Column -->
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'recordNo'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showTrademarkInfoForm(props.row)" variant="primary" style="cursor: pointer;">
                                <feather-icon icon="MousePointerIcon" class="mr-25" />
                                <span>{{ props.row.recordNo }}</span>
                            </b-badge>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'logo'" class="text-nowrap">
                    <b-row>
                        <b-col v-if="props.row.logo" class="font-size: x-small">
                            <a :href="props.row.logo" target="_blank">
                                <img :src="props.row.logo" :alt="$t('trademark.logo')" style="max-height:40px; width:auto;" />
                            </a>
                        </b-col>
                    </b-row>
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                        </span>
                        <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        row2Value: {
            type: String
        },
    },
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            columns: [],
            rows: [],
            searchTerm: '',
            isAgent: false,
            isOwner: false,
            name: '',
            showLanguageSelect: false,
        }
    },
    methods: {
        openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
        changeColumns(fieldName, labelName, status) {
            if (status) {
                if (fieldName.indexOf("Date") > -1) {
                    var item = {
                        label: this.$t('trademarkTransactionReportDetail.XXX'.replace("XXX", labelName)),
                        field: fieldName,
                        formatFn: this.$formatFn
                    }
                    this.columns.push(item);
                } else {
                    var item = {
                        label: this.$t('trademarkTransactionReportDetail.XXX'.replace("XXX", labelName)),
                        field: fieldName,
                    }
                    this.columns.push(item);
                }

            } else {
                const index = this.columns.findIndex(i => i.field === fieldName)
                this.columns.splice(index, 1);
            }
        },
        showTrademarkInfoForm(row) {
            this.$refs.trademarkForm.showInfo(row.id)
        },
        showData(data) {
            this.$refs.trademarkTransactionReportDetailModal.show()
            this.columns = [{
                    label: this.$t('trademarkTransactionReportDetail.logo'),
                    field: 'logo',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.record_no'),
                    field: 'recordNo',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.name'),
                    field: 'name',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.agent'),
                    field: 'agent',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.owner'),
                    field: 'owner',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.application_no'),
                    field: 'applicationNo',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.register_no'),
                    field: 'registerNo',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.nice_class'),
                    field: 'niceClass.niceClass',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.trademark_status'),
                    field: 'trademarkStatus',
                },
                {
                    label: this.$t('trademarkTransactionReportDetail.next_renewal_date'),
                    field: 'trademarkRenewal.nextRenewalDate',
                    formatFn: this.$formatFn
                }
            ]
            this.$refs.trademarkTransactionReportDetailModal.show()
            this.rows = data
        },
        exportExcel(lang) {
            const columnsTranslated = this.columns.map(col => {
                const fieldKey = col.field.replace(/\./g, "_").replace(/([A-Z])/g, "_$1").toLowerCase(); // application_No  → application_no
                const translatedLabel = this.$t(`trademarkTransactionReportDetail.${fieldKey}`, lang)
                return {
                    ...col,
                    label: translatedLabel
                }
            })

            const controller = {
                name: 'Trademark',
                actionName: 'CanExport'
            }

            const data = {
                columnList: columnsTranslated,
                dataList: this.rows
            }

            const payload = {
                data: data,
                controller: controller
            }

            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    const filename = lang === 'tr' ? 'Marka Listesi' : 'Trademark List'
                    this.$downloadFile(filename, response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
                this.showLanguageSelect = false
            })
        }
    },
}
</script>

<style>
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
